import React from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from "react-icons/ai";
import authService from "../services/authService";
import { clearAllAuthData } from "../utils/tokenUtils";

const styles = {
  header: {
    height: 62,
    display: "flex",
    alignItems: "center",
    background: "rgba(255,255,255,0.85)",
    borderBottom: "1.5px solid #e4f2fa",
    paddingLeft: 28,
    paddingRight: 28,
    borderTopLeftRadius: 14,
    borderTopRightRadius: 14,
    gap: 13,
    position: "sticky",
    top: 0,
    zIndex: 101,
    backdropFilter: "blur(6px)",
    marginBottom: 9,
    fontFamily: "'Inter','Poppins',sans-serif",
  },
  avatar: {
    width: 35,
    height: 35,
    borderRadius: "50%",
    background: "linear-gradient(135deg,#38b6ff,#6659fd)",
    color: "#fff",
    fontWeight: 900,
    fontSize: 19,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
  },
  name: {
    fontWeight: 700,
    color: "#3b74c1",
    letterSpacing: ".01em",
    fontSize: 18,
  },
  toggleBtn: {
    border: "1px solid rgba(26, 134, 217, 0.2)",
    background: "rgba(255, 255, 255, 0.95)",
    color: "#1a86d9",
    fontSize: 24,
    marginLeft: 14,
    cursor: "pointer",
    borderRadius: "8px",
    width: 40,
    height: 40,
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 4px rgba(26, 134, 217, 0.15)",
    position: "relative",
    zIndex: 102,
    pointerEvents: "auto",
  },
  right: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    gap: 15,
  },
  logout: {
    background: "#62d7ff",
    color: "#326",
    fontWeight: 700,
    border: "none",
    borderRadius: "0.8rem",
    padding: "8px 20px",
    fontSize: "1rem",
    cursor: "pointer",
    boxShadow: "0 2px 8px #bef1ff44"
  },
};

export default function AdminHeader({ sidebarOpen, setSidebarOpen, isMobile = false }) {
  const adminName = "Admin";
  const navigate = useNavigate();
  
  async function handleLogout() {
    try {
      // Call admin logout API - this will clear auth data in its finally block
      await authService.adminLogout();
    } catch (error) {
      // Even if API call fails, ensure data is cleared
      console.error('Logout error:', error);
      clearAllAuthData();
    }
    // Navigate to login page after logout completes
    navigate("/admin/login", { replace: true });
  }
  return (
    <header 
      className="admin-header"
      style={{
        ...styles.header,
        paddingLeft: isMobile ? 15 : 28,
        paddingRight: isMobile ? 15 : 28,
      }}
    >
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        gap: 13, 
        flex: 1, 
        minWidth: 0,
        position: "relative",
        zIndex: 102,
        pointerEvents: "auto"
      }}>
        <span style={styles.avatar}>A</span>
        {!isMobile && <span style={styles.name}>{adminName}</span>}
        <button
          type="button"
          style={styles.toggleBtn}
          title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setSidebarOpen((prev) => !prev);
          }}
          aria-label={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#1a86d9";
            e.currentTarget.style.color = "#fff";
            e.currentTarget.style.boxShadow = "0 4px 8px rgba(26, 134, 217, 0.3)";
            e.currentTarget.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = styles.toggleBtn.background;
            e.currentTarget.style.color = styles.toggleBtn.color;
            e.currentTarget.style.boxShadow = styles.toggleBtn.boxShadow;
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          {sidebarOpen ? <AiOutlineMenuFold /> : <AiOutlineMenuUnfold />}
        </button>
      </div>
      <div style={styles.right}>
        <button 
          style={{
            ...styles.logout,
            padding: isMobile ? "6px 15px" : "8px 20px",
            fontSize: isMobile ? "0.9rem" : "1rem",
          }} 
          onClick={handleLogout}
        >
          {isMobile ? "Logout" : "Logout"}
        </button>
      </div>
    </header>
  );
}
